import React from 'react';
import aboutHeader from '../assets/about-header.webp';
import about2 from '../assets/about-2.webp';
import Button from '../components/Buttons/Button';
import { Link } from 'react-router-dom';
import { ALIGNMENT_CLASSES } from '../utils/constants';
import { Blurhash } from "react-blurhash";
import { useState } from 'react';

const About: React.FC = () => {
    const [imagesLoaded, setImagesLoaded] = useState({
        header: false,
        about2: false,
    });

    const [messaging] = useState(process.env.REACT_APP_MESSAGING);

    const research = messaging === "research";

    return (
        <div>
            {/* Hero Section */}
            <div className="bg-muted-lightGrey">
                <div className={ALIGNMENT_CLASSES + " py-16"}>
                    <div className="grid md:grid-cols-2 gap-8">
                        {/* Column 1 - Text */}
                        <div className="space-y-6 p-8">
                            <h1 className="text-4xl md:text-5xl font-bold font-poppins text-left mb-8">
                                {research ? "Support Wellness Practitioners" : "Find your community, grow together."}
                            </h1>
                            <p className="font-noto text-lg text-left">
                                {research 
                                  ? "We're building a platform to help wellness practitioners share their events and connect with those who need them most. Whether you offer sound healing, kirtan, sober dance spaces, or transformative workshops, we want to make it easier for you to grow your community and reach the right audience."
                                  : "With so many spaces, practitioners, and gyms hosting events, it can be hard to find wellness experiences that truly suit you. Whether you're looking for sound healing, a sober place to dance, kirtan, or a healing workshop, we're here to help you connect with events that make you feel alive."
                                }
                            </p>
                        </div>

                        {/* Column 2 - Image */}
                        <div className="hidden md:flex items-center justify-center p-16">
                            <div className="relative w-full h-[300px] rounded-[30px] overflow-hidden">
                                <Blurhash
                                    hash="L4EL]An300?]+?spJDog00.8_2H?"
                                    width="100%"
                                    height="100%"
                                    resolutionX={32}
                                    resolutionY={32}
                                    punch={1}
                                    className={`w-full h-[300px] ${
                                        imagesLoaded.header ? 'animate-fade-out' : ''
                                    }`}
                                />
                                <img 
                                    src={aboutHeader} 
                                    alt="About Header" 
                                    className={`absolute inset-0 w-full h-[300px] object-cover ${
                                        imagesLoaded.header ? 'animate-fade-in' : 'opacity-0'
                                    }`}
                                    onLoad={() => setTimeout(() => 
                                        setImagesLoaded(prev => ({ ...prev, header: true })), 100
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Practitioners Section */}
            <div className={ALIGNMENT_CLASSES + " py-16"}>
                <div className="grid md:grid-cols-2 gap-8 items-center">
                    {/* Column 1 - Images */}
                    <div className="space-y-4 flex justify-center p-16">
                        <div className="relative w-full h-[400px]  rounded-[30px] overflow-hidden">
                            <Blurhash
                                hash="LCBgSN9Es?IU~q00%MMy%N9E%3IV"
                                width="100%"
                                height="100%"
                                resolutionX={32}
                                resolutionY={32}
                                punch={1}
                                className={`w-full h-full ${
                                    imagesLoaded.about2 ? 'animate-fade-out' : ''
                                }`}
                            />
                            <img 
                                src={about2} 
                                alt="About 2" 
                                className={`absolute inset-0 w-full h-[400px] md:h-[500px] object-cover ${
                                    imagesLoaded.about2 ? 'animate-fade-in' : 'opacity-0'
                                }`}
                                onLoad={() => setTimeout(() => 
                                    setImagesLoaded(prev => ({ ...prev, about2: true })), 100
                                )}
                            />
                        </div>
                    </div>

                    {/* Column 2 - Text and Button */}
                    <div className="space-y-6 p-8">
                        <h2 className="text-3xl md:text-4xl font-bold font-poppins text-left">
                           {research ? "More time for what you love" : "For practitioners"}
                        </h2>
                        <p className="font-noto text-lg text-left pb-8">
                            {research 
                                ? "Help us create the tools you need to promote your events effortlessly. By sharing your insights, you'll not only shape a platform designed for you but also get a chance to have your events amplified. Take a moment to fill out our survey—your voice matters in building a better way to connect, share, and grow."
                                : "Share your passion and grow your business with Soundness.events. List your events, reach a wider audience, and connect with people who value what you do. We make it simple to showcase your offerings and build a loyal following. Sign up today to register as a practitioner and start sharing your practice with the world."}
                        </p>
                        {/* <Link to="/profile"> */}
                            <Button onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSeHqkMcj2L6XEi1nPsfFO-MrAIQ_9TzueyiKJEDLiCHtcAnZA/viewform?usp=header', '_blank')}>{research ? "Take the Survey" : "Sign Up"}</Button>
                        {/* </Link> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;